import { Box, Text, Tooltip } from '@chakra-ui/react';

import styles from '@/pages/telephony/numbers/edit/cellRenderer/StatusCellRenderer.module.css';
import TrunkStatuses from '../utils/statuses';

const TrunkStatusCellRenderer = ({
    value,
    noCircle,
    statusMessage,
    parent = false,
}) => {
    const tooltipLabel =
        (TrunkStatuses[value]?.toolTip ? TrunkStatuses[value]?.toolTip : '') +
        (statusMessage ? `: ${statusMessage}` : '');

    const noMessage = !statusMessage && !TrunkStatuses[value]?.toolTip;

    const displayName =
        parent && value === 0 ? 'OK' : TrunkStatuses[value]?.displayedName;

    return (
        <Tooltip
            hasArrow
            disabled={noMessage}
            maxW="400px"
            width="auto"
            label={!noMessage && <Text textAlign="left">{tooltipLabel}</Text>}
            aria-label={TrunkStatuses[value]?.toolTip}>
            <Box
                className={`${styles.tag} ${styles[TrunkStatuses[value]?.type + 'Tag']}`}
                sx={{
                    display: 'flex',
                    alignItems: noCircle ? 'center' : null,
                    justifyContent: noCircle ? 'center' : null,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}>
                {!noCircle && (
                    <div
                        className={`${styles.circle} ${styles[TrunkStatuses[value]?.type + 'Circle']}`}
                    />
                )}
                <Text isTruncated>{displayName}</Text>
            </Box>
        </Tooltip>
    );
};

export default TrunkStatusCellRenderer;
